export default __webpack_public_path__ + "0b9fd41a95f5cbee1a32601540bee83a.jpg";